import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import styles from "./ReportsPage.module.css";

import VehicleSelector
    from "./components/VehicleSelector/VehicleSelector";

import ReportRangeSelector
    from "./components/ReportRangeSelector/ReportRangeSelector";

import ReportsSlider
    from "./components/ReportsSlider/ReportsSlider";

import getReports
    from "./services/getReports";

import { selectCars } from "../redux/car/car-slice";
import { useLocation } from "react-router-dom";


const ReportsPage = () => {

    const cars = useSelector(selectCars);

    const location = useLocation();

    const initialCarId = location.state?.carId;

    const [vehicleId, setVehicleId] =
        useState(initialCarId ?? "");

    const [range, setRange] =
        useState(0);


    const [reportData, setReportData] =
        useState(null);


    const [isLoading, setIsLoading] =
        useState(false);


    const [error, setError] =
        useState(null);


    /*
     * انتخاب خودرو
     *
     * اگر هنوز خودرویی انتخاب نشده باشد،
     * اولین خودرو به صورت پیش‌فرض انتخاب می‌شود.
     */
    useEffect(() => {

        if (
            !vehicleId &&
            cars?.length
        ) {

            setVehicleId(
                String(cars[0].id)
            );

        }

    }, [cars, vehicleId]);


    /*
     * دریافت گزارش
     *
     * با تغییر خودرو یا بازه زمانی،
     * گزارش جدید از Backend دریافت می‌شود.
     */
    useEffect(() => {

        if (!vehicleId) {

            setReportData(null);

            return;

        }


        let cancelled = false;


        const loadReports = async () => {

            try {

                setIsLoading(true);

                setError(null);


                const result =
                    await getReports(
                        vehicleId,
                        range
                    );


                if (cancelled) {
                    return;
                }


                if (!result?.isSuccess) {

                    throw new Error(
                        result?.message ||
                        "دریافت گزارش با خطا مواجه شد."
                    );

                }


                /*
                 * هیچ محاسبه‌ای در Frontend
                 * انجام نمی‌شود.
                 *
                 * data دقیقاً همان چیزی است
                 * که Backend ارسال کرده است.
                 */
                setReportData(
                    result.data
                );


            } catch (error) {

                if (cancelled) {
                    return;
                }


                console.error(
                    "Load reports error:",
                    error
                );


                setReportData(null);


                setError(
                    error?.message ||
                    "دریافت گزارش با خطا مواجه شد."
                );


            } finally {

                if (!cancelled) {

                    setIsLoading(false);

                }

            }

        };


        loadReports();


        return () => {

            cancelled = true;

        };


    }, [vehicleId, range]);


    return (

        <main className={styles.page}>

            <section className={styles.filters}>

                <ReportRangeSelector

                    value={range}

                    onChange={setRange}

                />


                <VehicleSelector

                    value={vehicleId}

                    onChange={setVehicleId}

                    options={cars || []}

                />

            </section>


            {

                error && (

                    <div

                        className={styles.error}

                        role="alert"

                    >

                        {error}

                    </div>

                )

            }


            <ReportsSlider

                data={reportData}

                loading={isLoading}

            />

        </main>

    );

};


export default ReportsPage;
